import { render, staticRenderFns } from "./preview-video.vue?vue&type=template&id=3c2c3900&scoped=true&"
import script from "./preview-video.vue?vue&type=script&lang=ts&"
export * from "./preview-video.vue?vue&type=script&lang=ts&"
import style0 from "./preview-video.vue?vue&type=style&index=0&id=3c2c3900&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c3900",
  null
  
)

export default component.exports